var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"construction"},[_c('div',{staticClass:"container-info"},[_c('img',{staticClass:"image",attrs:{"src":"/assets/building.png","alt":"Construction Web"}}),_c('h1',{staticClass:"title"},[_vm._v("Nuestro sitio web está en construcción")]),_c('p',[_vm._v("¡En breves estaremos listos para ti!")])])])
}]

export { render, staticRenderFns }